export enum ChannelEnum {
  WEBCHECKOUTPLUS = "WEBCHECKOUTPLUS",
  SHOPIFY = "SHOPIFY",
  WEBCHECKOUTEXPRESS = "EXPRESS_CHECKOUT",
}
